// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"82379331","404":"90a2711a","787":"0f8d78ff"}[chunkId] + ".chunk.js";
};